import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import useJwt from '@src/auth/jwt/useJwt'
const config = useJwt.jwtConfig
const headers = {
  token: localStorage.getItem(config.storageTokenKeyName),
  userID: localStorage.getItem('userID')
}

// PCO report: active vehicles registered in the date range with their PCO licence number.
export const getVehiclePcoReport = createAsyncThunk('appVehicle/getVehiclePcoReport', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Reports/GetVehiclePcoReport', params, { mode: 'cors' })
  return response.data
})

export const addVehicle = createAsyncThunk('appVehicle/Create', async (Vehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/Create', Vehicle, { mode: 'cors' })

  return response
})

export const getVehicleClass = createAsyncThunk('appVehicle/getVehicleClass', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleClassList', { headers })
  return response.data
})

export const getVehicleType = createAsyncThunk('appVehicle/getVehicleType', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleTypeList', params, {mode: 'cors'}, { headers })
  return response.data
})

export const getLicenseType = createAsyncThunk('appVehicle/getLicenseType', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetLicenseTypeList', params, {mode: 'cors'}, { headers })
  return response.data
})

export const GetVehicleForWebBookerScreen = createAsyncThunk('appDriver/GetVehicleList', async (params) => {
      
  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehiclePricingListForClientPortal', params, {mode:'cors'})
   
  return response.data
})

export const GetVehicleForWebBookerScreenWB = createAsyncThunk('appDriver/GetVehicleList', async (params) => {
      
  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehiclePricingListForWebBooker', params, {mode:'cors'})
   
  return response.data
})


export const GetHourListForWebBookerScreen = createAsyncThunk('appDriver/GetHourListForWebBookerScreen', async () => {
     
  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetHourListForWebBookerScreen', {mode:'cors'})
   
  return response.data
})

export const getSubCompany = createAsyncThunk('appVehicle/getSubCompany', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetSubCompanyList', { headers })
  return response.data
})

export const getNationality = createAsyncThunk('appVehicle/getNationality', async () => {

  const response = await axios.get('https://api.zasway.com:8443/Common/GetNationalityList', { headers })
  return response.data
})

export const GetVehicleTag = createAsyncThunk('appVehicle/GetVehicleTagList', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleTagList', { mode: 'cors' })

  return response.data
})

export const getAllData = createAsyncThunk('appVehicle/GetTableSummary', async (GetVehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetTableSummary', GetVehicle, { mode: 'cors' })

  return response.data
})
export const getVehicleStats = createAsyncThunk('appVehicle/GetVehicleStatistics', async (GetVehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleStatistics', GetVehicle, { mode: 'cors' })

  return response.data
})
export const getVehicleBookingCount = createAsyncThunk('Vehicle/GetVehicleBookingCount', async (GetVehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleBookingCount', GetVehicle, { mode: 'cors' })

  return response.data
})
export const GetDriver = createAsyncThunk('appDriver/GetDriverList', async (GetDriver) => {

  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverList', GetDriver, { mode: 'cors' })

  return response.data
})

export const getDocumentTypeList = createAsyncThunk('appDriver/getDocumentTypeList', async (OwnerType) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentTypeList', OwnerType, { mode: 'cors' })

  return response.data
})
export const deleteDocument = createAsyncThunk('appDriver/DeleteDocument', async (id) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/DeleteDocument', id, { mode: 'cors' })
  return response
})
export const EditDocument = createAsyncThunk('appDriver/UpdateDocument', async (formData) => {
  let flag = 0
  const response = await axios.post('https://api.zasway.com:8443/Common/UpdateDocument', formData, { mode: 'cors' })

  if (response.data.code === 200) { flag = 1 }
  return {
    response,
    isSaved: flag
  }
})
export const getDocument = createAsyncThunk('appDriver/getDocument', async (Doc) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocument', Doc, { mode: 'cors' })
  return response.data
})
export const addDocument = createAsyncThunk('appDriver/CreateDocument', async (formData) => {
  let flag = 0
  const response = await axios.post('https://api.zasway.com:8443/Common/Create', formData, { mode: 'cors' })

  if (response.data.code === 200) { flag = 1 }
  return {
    response,
    isSaved: flag
  }
})

export const resetFlag = createAsyncThunk('appDriver/ResetFlag', () => {

  return { isSaved: 0 }
})
export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerType', Owner, { mode: 'cors' })

  return response.data
})
export const GetDocumentDetailsByID = createAsyncThunk('appDriver/GetDocumentDetailsByID', async (document) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentDetailByID', document, { mode: 'cors' })

  return response.data
})

export const SetDocumentDetailsEmptyInStore = createAsyncThunk('appDriver/SetDocumentDetailsEmptyInStore', (show) => {

  return {
    isShowAddDocumentModel: show
  }
})


export const getData = createAsyncThunk('appVehicle/getData', async (params) => {


  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetTableSummary', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})
export const getVehicle = createAsyncThunk('appVehicle/getVehicle', async (params) => {


  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetTableSummary', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})
export const EditVehicle = createAsyncThunk('appVehicle/Update', async (Vehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/Update', Vehicle, { mode: 'cors' })

  return response
})
export const deleteVehicle = createAsyncThunk('appVehicle/Delete', async (id, { dispatch, getState }) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/Delete', id, { mode: 'cors' })

  await dispatch(getData(getState().vehicle.params))

  return response
})

export const addUser = createAsyncThunk('appVehicle/addUser', async (user, { dispatch, getState }) => {

  await axios.post('https://api.zasway.com:8443/User/CreateUser', user, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appVehicle/deleteUser', async (id, { dispatch, getState }) => {

  await axios.post('https://api.zasway.com:8443/User/DeleteUser', { id }, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})
export const getUser = createAsyncThunk('appUsers/getUser', async () => {

  const response = await axios.get('https://api.zasway.com:8443/Vendor/GetVendorList', { headers }, data)
  return response.data
})

export const getVehicleWeekDays = createAsyncThunk('appVehicle/getVehicleWeekDays', async (GetWDDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleWeekDays', GetWDDetails, { mode: 'cors' })
  return {
    data: response.data
  }
})

export const getVehicleBookingTrends = createAsyncThunk('appVehicle/getvehicleBookingTrends', async (GetBTDetails) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetvehicleBookingTrends', GetBTDetails, { mode: 'cors' })

  return {
    data: response.data
  }
})

export const getAllBookingTrends = createAsyncThunk('appVehicle/getAllBookingTrends', async (GetBTDetails) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetAllBookingTrends', GetBTDetails, { mode: 'cors' })

  return {
    data: response.data
  }
})

export const appVehicleSlice = createSlice({
  name: 'appVehicle',
  initialState: {
    data: [],
    isShowAddDocumentModel: false,
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedDocument: [],
    VehicleWeekDaysData: [],
    VehicleBookingTrends: [],
    AllBookingTrends: [],
    IsSaved: 0,
    typelist: [],
    Loader : false
  },
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getVehicleWeekDays.fulfilled, (state, action) => {
        state.VehicleWeekDaysData = action.payload.data
      })

      .addCase(getDocumentTypeList.fulfilled, (state, action) => {
        state.typelist = action.payload.data
      })

      .addCase(getVehicleBookingTrends.fulfilled, (state, action) => {

        state.VehicleBookingTrends = action.payload.data
      })

      .addCase(getAllBookingTrends.fulfilled, (state, action) => {

        state.AllBookingTrends = action.payload.data
      })

      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
      })
      .addCase(getVehicle.fulfilled, (state, action) => {
        state.selectedUser = action.payload.allData[0]
      })
      .addCase(GetDocumentDetailsByID.fulfilled, (state, action) => {
        state.selectedDocument = action.payload
      })
      .addCase(addDocument.fulfilled, (state, action) => {
        state.IsSaved = action.payload.isSaved
      })
      .addCase(EditDocument.fulfilled, (state, action) => {
        state.IsSaved = action.payload.isSaved
      })
      .addCase(resetFlag.fulfilled, (state, action) => {
        state.IsSaved = action.payload.isSaved
      })
      .addCase(SetDocumentDetailsEmptyInStore.fulfilled, (state, action) => {

        state.isShowAddDocumentModel = action.payload
      })   
      .addCase(GetVehicleForWebBookerScreen.pending, (state) => {
        state.Loader = true
      }) 
      .addCase(GetVehicleForWebBookerScreen.fulfilled, (state) => {
        state.Loader = false
      }) 
  }
})

export default appVehicleSlice.reducer
